<template>
  <div id="check-in-page-history">
    <p class="subheader-style">
      <v-icon
        large
        left
        color="#37474F"
      >
        mdi-history
      </v-icon>
      Your Previous Check-out
    </p>
    <v-card
      elevation="0"
      color="#FFF"
      class="check-in-history"
    >
      <div
        v-if="
          !isPreviousRecordAvailable || isCheckedInFromKiosk || !isNotCostShift
        "
        class="empty-alert-div"
      >
        <br>
        <br>
        <br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>
          No records found
        </p>
        <br>
        <br>
      </div>
      <div
        v-if="
          isPreviousRecordAvailable && !isCheckedInFromKiosk && isNotCostShift
        "
      >
        <v-card-text>
          <p class="title-text-style">
            Project:
            <span class="value-text-style">
              {{ previousCheckInDetails.project.name }}
            </span>
          </p>
          <p class="title-text-style">
            Check-out Gate :
            <span
              v-if="previousCheckInDetails.checkout_gate !== null"
              class="value-text-style"
            >
              {{ previousCheckInDetails.checkout_gate.name }}
            </span>
            <span
              v-else
              class="value-text-style"
            >{{
              previousCheckInDetails.checkin_gate.name
            }}</span>
          </p>
          <p class="title-text-style">
            Check-in Type :
            <span class="value-text-style">
              {{ previousCheckInDetails.type | arrangePretty }}
            </span>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <div class="action-btn-icon">
            <p class="title-text-style">
              Continue Same Check-out?
              <v-btn
                color="#37474F"
                elevation="0"
                fab
                x-small
                @click="repeatPreviousCheckOut()"
              >
                <v-icon> mdi-chevron-right </v-icon>
              </v-btn>
            </p>
          </div>
        </v-card-actions>
      </div>
    </v-card>
    <center-spinner :loading="loading" />
    <alert-dialog
      v-if="showAlert"
      :title="'⚠️ Checking out Too Early ?'"
      :message="'You have logged less than 15 minutes. If you proceed, the timesheet will be deleted as its considered invalid. Do you want to continue with check-out?'"
      @closed="showAlert = false"
      @confirmed="checkoutConfirmed()"
    />
    <check-out-sheet
      v-if="openCheckOutSheet"
      :location-enable-check="locationEnableCheck"
      :previous-gate="previousCheckInDetails.checkout_gate.id"
      @closed="openCheckOutSheet = false"
    />
  </div>
</template>
<script>
import spinner from '../../components/SpinnerCentre.vue';
import Constants from 'src/constants';
import AlertDialog from 'src/views/components/AlertDialog.vue';
import CheckOutSheet from './CheckOutSheet.vue';
export default {
  name: 'CheckOutPageHistory',
  components: {
    'center-spinner': spinner,
    'alert-dialog': AlertDialog,
    'check-out-sheet': CheckOutSheet,
  },
  filters: {
    arrangePretty (val) {
      if (val === 'staff') {
        return 'Site Manager';
      } else {
        return val;
      }
    },
  },
  data: () => ({
    loading: false,
    hours: null,
    minutes: null,
    showAlert: false,
    openCheckOutSheet: false,
  }),
  computed: {
    previousCheckInDetails () {
      return this.$store.getters['swiftuser/getPreviousCheckInDetails'];
    },
    userData () {
      return this.$store.getters.getSelectedOrganization;
    },
    isPreviousRecordAvailable () {
      if (Object.keys(this.previousCheckInDetails).length > 0) {
        return true;
      }
      return false;
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    userCurrentCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    orgSettings () {
      return this.$store.getters['organization/getOrganizationSettings'];
    },
    locationEnableCheck () {
      return this.orgSettings.location_verification;
    },
    isCheckedInFromKiosk () {
      if (
        this.previousCheckInDetails.checkout_kiosk !== null ||
        this.previousCheckInDetails.checkin_kiosk !== null
      ) {
        return true;
      }
      return false;
    },
    isNotCostShift () {
      if (
        this.previousCheckInDetails.checkin_method_type !== 'cost-shift' &&
        this.previousCheckInDetails.checkout_method_type !== 'cost-shift'
      ) {
        return true;
      }
      return false;
    },
  },
  async mounted () {
    await this.setClock();
    await this.getPreviousCheckInDetails();
  },
  methods: {
    async getPreviousCheckInDetails () {
      this.loading = true;
      await this.$store
        .dispatch('swiftuser/fetchPreviousCheckInDetails', {
          orgExtId: this.selectedOrganization.organization.external_id,
        })
        .catch(() => {
          this.loading = false;
        });
      this.loading = false;
    },
    repeatPreviousCheckOut () {
      var breakTime = localStorage.getItem('breakTime');
      if (breakTime !== null) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please remove the break before check-out!',
          type: Constants.ALERT_TYPE_INFO,
        });
        return;
      }
      if (this.userData.timesheet_tracking) {
        if (Number(this.hours) === 0) {
          if (Number(this.minutes) >= 15) {
            if (
              this.previousCheckInDetails.type !==
                this.userCurrentCheckInDetails.type ||
              this.previousCheckInDetails.project.id !==
                this.userCurrentCheckInDetails.project.id
            ) {
              this.$store.dispatch(
                'alert/onAlert',
                {
                  message:
                    'The selected type or project does not match your current check-in. Please try checking out using one of the alternative ways given.',
                  type: Constants.ALERT_TYPE_ERROR,
                },
                { root: true },
              );
            } else {
              this.loading = true;
              this.$store.dispatch('swiftuser/storeCheckOutMethodType', {
                type: 'manual-onsite',
              });
              setTimeout(() => {
                // if (this.previousCheckInDetails.checkout_gate !== null) {
                //   this.$router.push(
                //     `/check-out/${this.previousCheckInDetails.checkout_gate.id}/${this.previousCheckInDetails.type}`
                //   );
                //   this.loading = false;
                // } else {
                //   this.$router.push(
                //     `/check-out/${this.previousCheckInDetails.checkin_gate.id}/${this.previousCheckInDetails.type}`
                //   );
                //   this.loading = false;
                // }
                this.openCheckOutSheet = true;
                this.showAlert = false;
                this.loading = false;
              }, 1000);
            }
          } else {
            if (
              this.previousCheckInDetails.type !==
                this.userCurrentCheckInDetails.type ||
              this.previousCheckInDetails.project.id !==
                this.userCurrentCheckInDetails.project.id
            ) {
              this.$store.dispatch(
                'alert/onAlert',
                {
                  message:
                    'The selected type or project does not match your current check-in. Please try checking out using one of the alternative ways given.',
                  type: Constants.ALERT_TYPE_ERROR,
                },
                { root: true },
              );
            } else {
              this.showAlert = true;
              this.loading = false;
            }
          }
        } else {
          if (
            this.previousCheckInDetails.type !==
              this.userCurrentCheckInDetails.type ||
            this.previousCheckInDetails.project.id !==
              this.userCurrentCheckInDetails.project.id
          ) {
            this.$store.dispatch(
              'alert/onAlert',
              {
                message:
                  'The selected type or project does not match your current check-in. Please try checking out using one of the alternative ways given.',
                type: Constants.ALERT_TYPE_ERROR,
              },
              { root: true },
            );
          } else {
            this.loading = true;
            this.$store.dispatch('swiftuser/storeCheckOutMethodType', {
              type: 'manual-onsite',
            });
            setTimeout(() => {
              // if (this.previousCheckInDetails.checkout_gate !== null) {
              //   this.$router.push(
              //     `/check-out/${this.previousCheckInDetails.checkout_gate.id}/${this.previousCheckInDetails.type}`
              //   );
              //   this.loading = false;
              // } else {
              //   this.$router.push(
              //     `/check-out/${this.previousCheckInDetails.checkin_gate.id}/${this.previousCheckInDetails.type}`
              //   );
              //   this.loading = false;
              // }
              this.openCheckOutSheet = true;
              this.showAlert = false;
              this.loading = false;
            }, 1000);
          }
        }
      } else {
        if (
          this.previousCheckInDetails.type !==
            this.userCurrentCheckInDetails.type ||
          this.previousCheckInDetails.project.id !==
            this.userCurrentCheckInDetails.project.id
        ) {
          this.$store.dispatch(
            'alert/onAlert',
            {
              message:
                'The selected type or project does not match your current check-in. Please try checking out using one of the alternative ways given.',
              type: Constants.ALERT_TYPE_ERROR,
            },
            { root: true },
          );
        } else {
          this.openCheckOutSheet = true;
          this.loading = false;
        }
      }
    },
    checkoutConfirmed () {
      if (
        this.previousCheckInDetails.type !==
          this.userCurrentCheckInDetails.type ||
        this.previousCheckInDetails.project.id !==
          this.userCurrentCheckInDetails.project.id
      ) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message:
              'The selected type or project does not match your current check-in. Please try checking out using one of the alternative ways given.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
      } else {
        this.showAlert = false;
        this.loading = true;
        this.$store.dispatch('swiftuser/storeCheckOutMethodType', {
          type: 'manual-onsite',
        });
        setTimeout(() => {
          // if (this.previousCheckInDetails.checkout_gate !== null) {
          //   this.$router.push(
          //     `/check-out/${this.previousCheckInDetails.checkout_gate.id}/${this.previousCheckInDetails.type}`
          //   );
          //   this.showAlert = false;
          //   this.loading = false;
          // } else {
          //   this.$router.push(
          //     `/check-out/${this.previousCheckInDetails.checkin_gate.id}/${this.previousCheckInDetails.type}`
          //   );
          //   this.showAlert = false;
          //   this.loading = false;
          // }

          this.openCheckOutSheet = true;
          this.showAlert = false;
          this.loading = false;
        }, 1000);
      }
    },
    setClock () {
      var checkInTime = localStorage.getItem('checkInTime');
      if (checkInTime === null) {
        this.hours = null;
        this.minutes = null;
        return;
      }
      this.StartClock();
    },
    StartClock () {
      var checkInTime = localStorage.getItem('checkInTime');
      if (checkInTime === null) {
        this.hours = null;
        this.minutes = null;
        return;
      }
      var parsedCheckInTime = JSON.parse(checkInTime);
      var updatedTime = +new Date();
      this.difference = updatedTime - parsedCheckInTime;
      var minutes = Math.floor(
        (this.difference % (1000 * 60 * 60)) / (1000 * 60),
      );
      var hours = Math.floor(
        (this.difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      this.hours = hours < 10 ? '0' + hours : hours;
      this.minutes = minutes < 10 ? '0' + minutes : minutes;
    },
  },
};
</script>
<style scoped>
#check-in-page-history {
  margin-top: 20px;
  padding-bottom: 80px;
}
</style>
